module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "thankYou"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h2', [_vm._v("Thank You")]), _vm._v(" "), _c('p', [_vm._v("Pencils For Kids UK is blessed with bighearted friends who donate their talent, resources and insights to bring our vision to life. With gratitude, we acknowledge:")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.thankYous), function(thankYou) {
    return _c('div', [_c('h5', {
      domProps: {
        "innerHTML": _vm._s(thankYou.name)
      }
    }), _vm._v(" "), _c('p', {
      domProps: {
        "innerHTML": _vm._s(thankYou.organization)
      }
    })])
  }))]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "scrim"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "img-fluid",
    attrs: {
      "src": require("assets/images/PFK_OurTeam_Photo4_ThankYou_260x260.jpg")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1bf27b13!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OurTeam/ThankYou.vue
// module id = 386
// module chunks = 2